// extracted by mini-css-extract-plugin
export default {"wrapper":"ContractDetails_wrapper__ftHTz","item":"ContractDetails_item__7U6DV","toprow":"ContractDetails_toprow__TU9T6"};